import { cn } from '@/lib/utils.ts'
import { MENU_SELECT_TOGGLE_DURATION } from '@/lib/constants/animationsSettings.ts'
import { ReactNode } from 'react'
import useOnSwipe from '@/lib/hooks/useCloseOnDragDown.ts'
import { useOverlayStore } from '@/components/common/propertyPopoverOverlay/overlay/useOverlayStore.ts'

type PropsT = {
  open: boolean
  className?: string
  children?: ReactNode
  handleSwipeDown?: () => void
}

export default function OverlaySelectWrapper({
  open,
  className,
  children,
  handleSwipeDown,
}: PropsT) {
  const { onTouchEnd, onTouchStart, onTouchMove } = useOnSwipe({
    onSwipeDown: handleSwipeDown,
  })
  const swipeDownDisabled = useOverlayStore(state => state.swipeDownDisabled)
  function disabledFallback() {}
//
//   return createPortal(
//       <div
//         onTouchStart={swipeDownDisabled ? disabledFallback : onTouchStart}
//         onTouchMove={swipeDownDisabled ? disabledFallback : onTouchMove}
//         onTouchEnd={swipeDownDisabled ? disabledFallback : onTouchEnd}
//         className={cn(
//           `fixed bottom-0 left-0 z-[10010] w-full md:w-[var(--sidebar-width)]`,
//           open ? `translate-y-0` : `pointer-events-none translate-y-[100%] opacity-0`,
//           MENU_SELECT_TOGGLE_DURATION,
//           className,
//         )}
//       >
//         <div className={`flex justify-center py-2 md:hidden`}>
//           <button
//             className={cn(
//               `h-1.5 w-20 rounded-full border bg-secondary duration-100`,
//               swipeDownDisabled ? 'opacity-80' : 'opacity-100',
//             )}
//           />
//         </div>
//         <div
//           onTouchStart={onTouchStart}
//           onTouchMove={onTouchMove}
//           onTouchEnd={onTouchEnd}
//           className={`absolute left-0 right-0 top-0 z-[1909] h-10 md:hidden`}
//         ></div>
//         {children}
//       </div>
//   ,document.body,)
// }

  return (
    <div
      onTouchStart={swipeDownDisabled ? disabledFallback : onTouchStart}
      onTouchMove={swipeDownDisabled ? disabledFallback : onTouchMove}
      onTouchEnd={swipeDownDisabled ? disabledFallback : onTouchEnd}
      className={cn(
        `fixed bottom-0 left-0 z-[10010] w-full md:w-[var(--sidebar-width)]`,
        open ? `translate-y-0` : `pointer-events-none translate-y-[100%] opacity-0`,
        MENU_SELECT_TOGGLE_DURATION,
        className,
      )}
    >
      <div className={`flex justify-center py-2 md:hidden`}>
        <button
          className={cn(
            `h-1.5 w-20 rounded-full border bg-secondary duration-100`,
            swipeDownDisabled ? 'opacity-80' : 'opacity-100',
          )}
        />
      </div>
      <div
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        className={`absolute left-0 right-0 top-0 z-[1909] h-10 md:hidden`}
      ></div>
      {children}
    </div>
  )
}
